/* Bois/Azerbia – 1 exemplaire max par produit (pack).
   Désactive "Ajouter au panier" si le produit est déjà au panier ; réactive sinon. */
(function () {
  function getQty(f) { var q = f.querySelector('input[name="quantity"]'); return q ? parseInt(q.value || "1", 10) : 1; }
  function apply(ids) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (getQty(f) < 2) return; // uniquement les produits "pack" (quantité forcée à N)
      var idEl = f.querySelector('[name="id"]'); if (!idEl) return;
      var vid = String(idEl.value);
      var btn = f.querySelector('[name="add"]') || f.querySelector('button[type="submit"]'); if (!btn) return;
      var span = btn.querySelector('span');
      var inCart = !!ids[vid];
      if (inCart && !btn.dataset.bmDisabled) {
        btn.dataset.bmDisabled = "1";
        btn.setAttribute("disabled", "disabled");
        btn.style.opacity = "0.6"; btn.style.cursor = "not-allowed";
        if (span) { btn.dataset.bmOrig = span.textContent; span.textContent = "Déjà dans le panier"; }
      } else if (!inCart && btn.dataset.bmDisabled) {
        btn.dataset.bmDisabled = "";
        btn.removeAttribute("disabled");
        btn.style.opacity = ""; btn.style.cursor = "";
        if (span && btn.dataset.bmOrig) span.textContent = btn.dataset.bmOrig;
      }
    });
  }
  function refresh() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { var ids = {}; (c.items || []).forEach(function (i) { ids[String(i.variant_id)] = true; }); apply(ids); })
      .catch(function () {});
  }
  if (document.readyState !== "loading") refresh(); else document.addEventListener("DOMContentLoaded", refresh);
  document.addEventListener("submit", function (e) { var f = e.target; if (f && f.action && f.action.indexOf("/cart/add") > -1) { setTimeout(refresh, 700); setTimeout(refresh, 1700); } }, true);
  ["cart:updated", "cart:refresh", "on:cart:add", "on:line-item:change"].forEach(function (ev) { document.addEventListener(ev, refresh); });
})();
